import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectTracks } from '@/store/tracks/selectors';

import { Flex, Progress, Typography } from 'antd';

import BadgeElement from '@shared/components/BadgeElement';
import { BADGE_SIZES } from '@shared/components/BadgeElement/constants';
import useIsMobile from '@shared/hooks/useIsMobile';

import classNames from 'classnames';

import css from './TrackRewards.module.scss';

const { Title } = Typography;

const BADGE_NAME_LENGTH = 12;

const TrackRewards = () => {
  const { t } = useTranslation('TrackId');
  const [isMobile] = useIsMobile(769);

  const { trackRewards, sectionsRewards, trackStudentPlanStatus } = useSelector(selectTracks);

  const activeSectionsRewards = sectionsRewards.filter(badge => badge.isRewarded).length;
  const progressPercent = sectionsRewards.length
    ? Math.round((activeSectionsRewards / sectionsRewards.length) * 100)
    : 0;

  const renderRewards = (badges, size = BADGE_SIZES.DEFAULT) =>
    badges.map(badge => {
      switch (size) {
        case BADGE_SIZES.SMALL:
          return (
            <BadgeElement
              key={`${badge?.id}-${size}`}
              data={badge}
              size={BADGE_SIZES.SMALL}
              disabled={!badge?.isRewarded}
              hideName
              tooltipKey='name'
            />
          );

        // Большая иконка
        default:
          const isSoloBadge = badges.length === 1;

          return (
            <BadgeElement
              key={`${badge?.id}-${size}`}
              className={isSoloBadge ? css['TrackRewards-reward-solo'] : ''}
              size={BADGE_SIZES.LARGE}
              data={badge}
              disabled={!badge?.isRewarded}
              maxNameLength={isSoloBadge ? 0 : BADGE_NAME_LENGTH}
            />
          );
      }
    });

  return (
    <Flex gap={16} vertical>
      <Title
        className={classNames(css['TrackRewards-title'], {
          [css['TrackRewards-title-inactive']]: !trackStudentPlanStatus,
        })}
        level={3}
      >
        {t('rewards')}
      </Title>

      {trackRewards?.length > 0 && (
        <Flex gap={isMobile ? 8 : 16} wrap justify='start'>
          {renderRewards(trackRewards)}
        </Flex>
      )}

      <div className={css['TrackRewards-reward-progress']}>
        <Progress percent={progressPercent} showInfo={false} />
        <div className={css['TrackRewards-reward-progress-text']}>
          {t('from', { count: activeSectionsRewards, maxCount: sectionsRewards.length })}
        </div>
      </div>

      {sectionsRewards?.length > 0 && (
        <Flex gap={isMobile ? 4 : 8} wrap className={css['TrackRewards-reward-width']}>
          {renderRewards(sectionsRewards, BADGE_SIZES.SMALL)}
        </Flex>
      )}
    </Flex>
  );
};

export default TrackRewards;
